/**
 * Delete Context Variable controller
 */

import * as contextVariableService from '../../data/services/contextVariableService';

/**
 * Delete a context variable
 * @param {string} id - Context variable ID
 * @returns {Promise<void>}
 */
export const deleteContextVariable = async (id) => {
  try {
    await contextVariableService.deleteContextVariable(id);
  } catch (error) {
    console.error('Error deleting context variable:', error);
    throw error;
  }
};

